import React from 'react';

import Button from 'components/Button';
import './styles.css';

const Buttons = ({
  triggerSubmit,
  submitButtonDisabled,
  submitting,
  onClose
}) => (
  <div className="Buttons">
    <Button onClick={onClose} transparent white className="cancel">
      Cancel
    </Button>
    <Button
      onClick={triggerSubmit}
      className="submit"
      blue={!submitButtonDisabled}
      isLoading={submitting}
      disabled={submitButtonDisabled}>
      Add
    </Button>
  </div>
);

export default Buttons;
